import { env } from '@/services/dev';
import utils from '@/services/tools';
import http from '@/services/http';

export default {
  bindAccount(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/user_account_bind_wwx`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
};
